import { createContext, useContext } from 'react';

const AdminPortalContext = createContext(false);

export const AdminPortalProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => (
  <AdminPortalContext.Provider value>
    {children}
  </AdminPortalContext.Provider>
);

export const useIsAdminPortal = (): boolean =>
  useContext(AdminPortalContext);
